module.exports = __webpack_public_path__ + "static/contact-map-0b258fd6f00883dc3cfb35739ef8a25d.jpg";